/* Update .eslintrc "polyfills" config as well for ESLint */
import 'regenerator-runtime/runtime'
import 'core-js/features/number'
import 'core-js/features/symbol'
import 'core-js/features/promise'
import 'core-js/features/object'
import 'core-js/features/array'
import 'core-js/features/string'
import 'core-js/web/dom-collections'
import 'core-js/web/url-search-params'



// WEBPACK FOOTER //
// ./utilities/polyfills.js